<template>
    <div>
        <div class="fixed right-0 bottom-4 bg-blue-500 flex p-1 px-2 rounded-l-lg shadow-lg cursor-pointer opacity-70"
            @click="loadData()">
            <span class="material-symbols-outlined text-white text-lg">
                flex_direction
            </span>
        </div>
        <a-drawer v-model:open="isTask" :title="$t('l_Task')" placement="right">
            <div class="flex flex-col gap-4">
                <a-empty v-if="isLoading == false && dataList.length == 0"></a-empty>
                <!-- box -->
                <div v-for="(item, index) in dataList" :key="index"
                    class="border rounded-lg h-16 flex gap-2 px-2 items-center">
                    <div class="bg-blue-50 w-7 h-7 flex justify-center items-center text-blue-700 rounded-full">
                        {{ dataList.length - index }}
                    </div>
                    <!-- <a-progress type="circle" :percent="30" :size="30" class="text-[10px]" /> -->

                    <!-- info -->
                    <div class="flex flex-col flex-1 overflow-hidden justify-around gap-1">
                        <div class="felx-1 text-ellipsis overflow-hidden whitespace-nowrap">
                            {{ item.name }}
                        </div>
                        <div class="text-gray-500 text-[10px]">{{ $timeFormat(item.startTime) }}</div>
                        <div class="mr-1">
                            <a-progress class="text-[8px] m-0 p-0"
                                :status="item.status == 'error' ? 'exception' : 'active'" :percent="item.percent || 0"
                                :size="3" />
                        </div>

                    </div>
                    <div class="text-2xl opacity-90">
                        <span v-if="item.status == 'error'" class="material-symbols-outlined" style="color:red">
                            error
                        </span>
                        <div v-if="item.status == 'success'" style="color:#1d4ed8">
                            <span v-if="['FILE', 'TEMP_URL'].includes(item?.result?.type)" class="material-symbols-outlined cursor-pointer"
                                @click="onDownload(index, item.result.type)">
                                enable
                            </span>
                            <span v-else class="material-symbols-outlined">
                                task_alt
                            </span>
                        </div>
                        <span v-else-if="item.status == 'in_progress'" class="material-symbols-outlined"
                            style="color:#1d4ed8">
                            clock_loader_20
                        </span>
                    </div>

                </div>
                <div class="h-20"></div>
                <div @click="loadData()"
                    class="bg-blue-500 shadow-lg absolute bottom-4 right-4 left-4 h-10 rounded-lg flex justify-center items-center text-white cursor-pointer">
                    {{ $t('l_Update') }}
                </div>
            </div>
        </a-drawer>
    </div>
</template>

<script>
import http from '@/utils/http';
import config from '@/config';
const baseURL = config.baseURL
export default {
    data() {
        return {
            isTask: false,
            isLoading: false,
            dataList: []
        }
    },
    mounted() {
        // this.loadData()
    },
    methods: {
        loadData() {
            this.isLoading = true;
            http({
                url: 'task/page',
                // __serviceUrl: 'taskController',
                data: {
                    length: 50
                }
            }).then(res => {
                this.isLoading = false;
                if (res.status == 0) {
                    this.dataList = JSON.parse(JSON.stringify(res.data))
                }
                this.isTask = true;
            }).catch(() => {
                this.isLoading = false;
            })
        },
        onDownload(index, type) {
            if(type == 'TEMP_URL') {
                const url = this.dataList[index]?.result?.url || null
                window.open(url, '_blank')
                return
            }
            const token = this.dataList[index]?.result?.token || null
            const url = baseURL + 'public/download/token?token=' + token
            window.open(url, '_blank')
        }
    },
}
</script>

<style lang="scss" scoped></style>